import { render, staticRenderFns } from "./ShippingSelector.vue?vue&type=template&id=0460ef76&"
import script from "./ShippingSelector.vue?vue&type=script&lang=js&"
export * from "./ShippingSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports